export enum DiTokens {
  Cognito = 'Cognito',
  CognitoLocations = 'CognitoLocations',
}
